import { render, staticRenderFns } from "./ClassroomSelector.vue?vue&type=template&id=7115b35e&scoped=true&"
import script from "./ClassroomSelector.vue?vue&type=script&lang=js&"
export * from "./ClassroomSelector.vue?vue&type=script&lang=js&"
import style0 from "./ClassroomSelector.vue?vue&type=style&index=0&id=7115b35e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7115b35e",
  null
  
)

export default component.exports